import React, { useState, useEffect } from 'react';
import BEMHelper from '@ynap/bem-helper';
import { Notification } from '@ynap/notification';
import ReactMarkdown from 'markdown-to-jsx';
import { object, string, array } from 'prop-types';
import { promotionType, marketingKey } from '@ynap/price';

const bem = new BEMHelper('PromoPrice');
const MOBILE_MAX_WIDTH = 768;

const PromoPrice = (props) => {
    const { messages, price, marketingProperties = [], promotionApplied } = props;

    const [notification, setNotification] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (notification) {
            const timer = setTimeout(() => {
                setNotification('');
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [notification]);

    if (promotionApplied === promotionType.NONE) {
        return null;
    }

    const promoCode = marketingProperties[marketingKey.PROMO_CODE] ?? '';
    const finalPriceTotal = parseFloat(marketingProperties[marketingKey.FINAL_PRICE] ?? '').toFixed(2);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(promoCode);
            setNotification(messages.notifications.promoPriceSuccess());
            setSuccess(true);
        } catch (err) {
            setNotification(messages.notifications.promoPriceError());
        }

        if (window.innerWidth <= MOBILE_MAX_WIDTH) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    if (promotionApplied === promotionType.MANUAL) {
        return (
            <div className={bem('promoPriceContainer', 'manualPromoPrice')}>
                <span className={bem('manualPromoPrice')}>
                    {price?.currency?.symbol}
                    {finalPriceTotal}
                </span>
                <span className={bem('diamondDivider')} />
                <span className={bem('promoMessage')}>
                    {messages?.promoPrice?.codeDescription()} {promoCode.replace(/\s/g, '')}
                </span>
                <button onClick={handleCopy} className={bem('clipboard')} />
                {notification && (
                    <Notification
                        type={success ? 'success-action' : 'error'}
                        className={bem('notification')}
                        message={<ReactMarkdown>{notification}</ReactMarkdown>}
                    />
                )}
            </div>
        );
    }

    if (promotionApplied === promotionType.AUTO) {
        return (
            <div className={bem('promoPriceContainer', 'autoPromoPrice')}>
                <span className={bem('autoPromoPrice')}>
                    {price?.currency?.symbol}
                    {finalPriceTotal}
                </span>
                <span className={bem('diamondDivider')} />
                <span className={bem('promoMessage')}>{messages?.promoPrice?.promotionalPrice()}</span>
            </div>
        );
    }

    return null;
};

PromoPrice.propTypes = {
    messages: object,
    id: string,
    price: object,
    marketingProperties: array,
    promotionApplied: string,
};

export default PromoPrice;
